import './ContactUsPage.scss';
import Navbar from '../../components/CommonComponents/Navbar/Navbar'
import { Box, Grid, TextField, Typography } from "@mui/material";
import { useState } from 'react';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import InfoIcon from '@mui/icons-material/Info';
import pageTextConfig from "../../assets/configs/Footer Config/textConfig";
import { FeedbackAPIHandler } from '../../services/NetworkClient/BackendAPIs/FeedbackAPIHandler'
import GGButton from '../../components/CommonComponents/GGButton/GGButton';
import SnackBar, { SnackTypes } from "../../components/UtilityComponents/SnackBar/SnackBar";
import { useRef } from 'react';
import GGLoaderView from '../../components/UtilityComponents/GGLoaderView/GGLoaderView';
import AddSpace from '../../components/UtilityComponents/AddSpace/AddSpace';
import Footer from '../../components/CommonComponents/Footer/Footer';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';
import { useEffect } from 'react';

const ContactUsPage = () => {
  const [tab, setTab] = useState(0);
  const [formData, setFormData] = useState({
    fullName: "",
    contactNo: "",
    email: "",
    message: ""
  });
  const [showLoader, setShowLoader] = useState(false);

  const snackBarRef = useRef<{ showSnackbar(): any }>(null)
  const [snackBarParams, setSnackBarParams] = useState({
    message: "",
    state: SnackTypes.error
  });

  useEffect(() => {
    document.title = "GenieGig | Contact Us";
    window.scrollTo(0, 0);
    logAnalyticsEvent(GGAnalyticsEvents.CONTACT_US_PAGE_LOADED);
  }, []);

  const showSnackbar = (message: string, state: SnackTypes) => {
    setSnackBarParams({ message: message, state: state })
    snackBarRef.current?.showSnackbar()
  }

  const resetFormData = () => setFormData({
    fullName: "",
    contactNo: "",
    email: "",
    message: ""
  });

  const handleFormData = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const fieldName = e.target.name;
    const val = e.target.value;
    setFormData({ ...formData, [fieldName]: val });
  };

  const submitFeedback = async () => {
    setShowLoader(true);
    try {
      const success = await FeedbackAPIHandler.shared.writeToUsFeedback(formData);
      if (success) {
        showSnackbar("Feedback submitted successfully!", SnackTypes.success);
        resetFormData();
      } else {
        throw new Error("Failed to submit feedback.");
      }
    } catch (error) {
      showSnackbar(error as string, SnackTypes.error);
    } finally {
      setShowLoader(false);
    }
  };

  // Add modal content
  const tab1TextConfig = pageTextConfig.footerTab1;
  const tab2TextConfig = pageTextConfig.footerTab2;

  const tab1 = () => (
    <>
      <Grid item xs={12}>
        <TextField 
          label={tab1TextConfig.fullName.label} 
          name={tab1TextConfig.fullName.name} 
          variant="outlined" 
          style={{ width: '100%' }} 
          value={formData.fullName} 
          onChange={(e) => handleFormData(e)} 
        />
      </Grid>
      <Grid item xs={6}>
        <TextField 
          label={tab1TextConfig.contactNo.label} 
          name={tab1TextConfig.contactNo.name} 
          variant="outlined" 
          style={{ width: '100%' }} 
          value={formData.contactNo} 
          onChange={(e) => handleFormData(e)} 
        />
      </Grid>
      <Grid item xs={6}>
        <TextField 
          label={tab1TextConfig.email.label} 
          name={tab1TextConfig.email.name} 
          variant="outlined" 
          style={{ width: '100%' }} 
          value={formData.email} 
          onChange={(e) => handleFormData(e)} 
        />
      </Grid>
      <Grid item xs={12} className="footer-message">
        <TextField
          label={tab1TextConfig.message.label}
          name={tab1TextConfig.message.name}
          variant="outlined"
          helperText={
            <Box className="description-footer">
              <Box className="helper-text">
                <InfoIcon sx={{ marginRight: "10px" }} />
                <Box>
                  <i>
                    {tab1TextConfig.message.helperText}
                  </i>
                </Box>
              </Box>
              <Box>
                Message length: {formData.message.length}
              </Box>
            </Box>
          }
          FormHelperTextProps={{ component: 'div' } as any}
          value={formData.message}
          multiline
          rows={5}
          inputProps={{ maxLength: 4000 }}
          sx={{ marginBottom: '30px' }}
          fullWidth
          onChange={(e) => handleFormData(e)}
        />
      </Grid>
      <Grid className="footerTabSubmitBtn" item xs={12}>
        <div className="submit-button-container">
          <GGButton className='submit-button' onClick={submitFeedback} variant='contained' sx={{ width:'200px', color: 'white', backgroundColor: '#000', '&:hover': { backgroundColor: '#333' } }}>
            Submit
          </GGButton>
        </div>
      </Grid>
    </>
  );

  const tab2 = () => (
    <>
      <Grid item xs={12} sm={3} display={"flex"} alignItems={"center"} fontSize={"12px"}>
        <CallIcon />
        <Typography marginLeft={"10px"} variant="h6" component="h2" textAlign={"left"} p={0}>{tab2TextConfig.contact.title}</Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <Typography variant="subtitle1" component="h2" textAlign={"left"}>{tab2TextConfig.contact.data}</Typography>
      </Grid>
      <Grid item xs={12} sm={3} display={"flex"} alignItems={"center"}>
        <EmailIcon />
        <Typography marginLeft={"10px"} variant="h6" component="h2" textAlign={"left"}>{tab2TextConfig.email.title}</Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <Typography variant="subtitle1" component="h2" textAlign={"left"}>{tab2TextConfig.email.data}</Typography>
      </Grid>
      <Grid item xs={12} sm={3} display={"flex"} alignItems={"center"}>
        <BusinessIcon />
        <Typography marginLeft={"10px"} variant="h6" component="h2" textAlign={"left"}>{tab2TextConfig.address.title}</Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <Typography variant="subtitle1" component="h2" textAlign={"left"}>{tab2TextConfig.address.data}</Typography>
      </Grid>
    </>
  );

  return (
    <div className='contact-us-page'>
      {showLoader && <GGLoaderView />}
      <SnackBar ref={snackBarRef} severity={snackBarParams.state} alertDuration={5000} message={snackBarParams.message} />
      
      <AddSpace vSpace={"10vh"} hSpace={"0"} />
      <Navbar useScrollVersion={true} />

      <div className="main-container">
        <div className="header">
          <div className="title">
            <Typography fontSize={32} fontWeight={700}>
              Contact Us
            </Typography>
            <Typography fontSize={16} fontWeight={400} color="text.secondary" sx={{ marginTop: 1 }}>
              Get in touch with us. We'd love to hear from you.
            </Typography>
          </div>
        </div>

        <div className="contact-content">
          <div className="tab-navigation">
            <div className={tab === 0 ? "footerTab active" : "footerTab"} onClick={() => setTab(0)}>
              <EditNoteIcon style={{ marginRight: "0.5rem" }} fontSize="inherit" />Write to Us
            </div>
            <div className={tab === 1 ? "footerTab active" : "footerTab"} onClick={() => setTab(1)}>
              <CallIcon style={{ marginRight: "0.5rem" }} fontSize="inherit" />Contact Info
            </div>
          </div>

          <div className="tab-content">
            <Grid container spacing={4}>
              {tab === 0 ? tab1() : tab2()}
            </Grid>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default ContactUsPage
